export default __webpack_public_path__ + "static/lower4_2-687fffe8718d0aa1d272276e5f136a69.jpg";